<template>
    <div class="screen__right right">
        <div class="header">
            <div :class="injectionStatus === injectionStatuses.ended || injectionStatus === injectionStatuses.running ? injectionStatuses.ended : injectionStatuses.interrupted" class="middle__header">
                <img v-if="injectionStatus === injectionStatuses.running" src="@/img/Protocol-menu.svg" alt="">
                <font-awesome-icon icon="fa-solid fa-check" v-if="injectionStatus === injectionStatuses.ended" />
                <font-awesome-icon v-if="injectionStatus === injectionStatuses.interrupted" icon="fa-solid fa-xmark"/>
                <h2 v-if="injectionStatus === injectionStatuses.running">Protocol</h2>
                <h2 v-if="injectionStatus === injectionStatuses.ended">Введение завершено</h2>
                <h2 v-if="injectionStatus === injectionStatuses.interrupted">Введение прервано</h2>
                <span style="flex-grow: 1"></span>
                <span class="time" v-if="isTimeExpiring">{{formattedTime}}</span>
            </div>
            <router-link :to="{name: 'Manager'}"
                         class="right__manager"
            >
                Менеджер протоколов
            </router-link>
        </div>
        <div class="script-options">
            <div class="d-flex min-width-0 flex-grow-1">
                <div class="fluid-source-date-time flex-shrink-0" v-if="injectionStatus === injectionStatuses.running">
                    <div class="fluid-source">
                        <div class="fluid-header">
                            <h2>Источник жидкости</h2>
                            <span>ml</span>
                        </div>
                        <div class="fluid-visual">
                            <FluidA/>
                            <FluidB/>
                        </div>
                    </div>
                    <DateTime/>
                </div>

                <InjectionProcessRunningView
                        v-if="injectionStatus === injectionStatuses.running"
                        :max-pressure="maxPressure"
                        @injection-started="injectionStarted"
                        @injection-interrupted="injectionInterrupted"
                        @injection-ended="injectionEnded"
                />
                <div v-if="injectionStatus === injectionStatuses.running" class="system-injection">
                    <div class="system-header">
                        <h2>Система</h2>
                        <div class="system-header-btn-container">
                            <button class="check-system-button system-btn"><img
                                    src="../../img/check-system-btn.svg" alt="">
                            </button>
                            <button class="confirm-button system-btn"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.49998 19C4.26963 19 0 14.7304 0 9.5C0 4.26967 4.26963 0 9.49998 0C14.7303 0 19 4.26967 19 9.5C19 14.7304 14.7303 19 9.49998 19ZM9.49998 1.06741C4.91008 1.06741 1.06742 4.80338 1.06742 9.5C1.06742 14.0899 4.80334 17.9326 9.49998 17.9326C14.1966 17.9326 17.9326 14.1966 17.9326 9.5C17.9326 4.91012 14.1966 1.06741 9.49998 1.06741Z" fill="#36393B"/>
                                <circle cx="9.5" cy="9.5" r="8.5" fill="#F8ED75"/>
                                <path d="M8.30402 13.7811C8.10402 13.7811 7.90402 13.6811 7.80402 13.4811L5.10406 9.5811C4.90406 9.28114 5.00402 8.88115 5.30402 8.68115C5.60402 8.48115 6.00404 8.58113 6.20404 8.88113L8.40405 12.0811L12.6041 6.28112C12.8041 5.98112 13.204 5.88115 13.504 6.18115C13.804 6.38115 13.9041 6.78114 13.6041 7.08114L8.90405 13.6811C8.70405 13.6811 8.50402 13.7811 8.30402 13.7811Z" fill="#36393B"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div class="system-window">
                        <svg width="20" height="52" viewBox="0 0 20 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.3 22.2001C19.2 22.1001 17.8 20.7001 17.8 16.8001C17.8 12.9001 18.4001 11.4001 18.4001 11.4001V11.3001V11.2001C18.4001 11.2001 18.1 8.4001 18.1 6.2001C18.1 4.7001 17.5001 3.80008 16.0001 3.30008V2.7001C16.0001 1.5001 15.0001 0.600098 13.9001 0.600098H13.0001C11.8001 0.600098 10.9001 1.6001 10.9001 2.7001V2.80008C10.6001 2.80008 10.3001 2.80008 10.0001 2.80008C9.80006 2.80008 9.60009 2.80008 9.40009 2.80008C9.40009 1.60008 8.40005 0.700104 7.30005 0.700104H6.50006C5.30006 0.700104 4.40009 1.70008 4.40009 2.80008V3.30008C2.70009 3.80008 2.00006 4.6001 2.00006 6.2001C2.00006 8.4001 1.70007 11.1001 1.70007 11.2001V11.3001V11.4001C1.70007 11.4001 2.30005 12.9001 2.30005 16.8001C2.30005 20.6001 0.900085 22.1001 0.900085 22.1001L0.800049 22.2001V27.4001V27.6001V29.9001C0.800049 30.7001 1.40007 31.3001 2.20007 31.3001H3.90009V45.4001L6.00006 47.2001V50.7001C6.00006 51.2001 6.40005 51.5001 6.80005 51.5001C7.30005 51.5001 7.60004 51.1001 7.60004 50.7001V47.2001L9.70007 45.4001V31.3001H10.7001V45.4001L12.8 47.2001V50.7001C12.8 51.2001 13.2 51.5001 13.6 51.5001C14.1 51.5001 14.4001 51.1001 14.4001 50.7001V47.2001L16.5001 45.4001V31.3001H18.2001C19.0001 31.3001 19.6 30.7001 19.6 29.9001V27.6001V27.4001V22.3001L19.3 22.2001Z" class="injector-body" fill="#FFFF99"/>
                            <path d="M13.7001 24.6001H6.20013C5.50013 24.6001 4.90015 25.2001 4.90015 25.9001C4.90015 26.6001 5.50013 27.2001 6.20013 27.2001H13.7001C14.4001 27.2001 15.0001 26.6001 15.0001 25.9001C15.0001 25.2001 14.4001 24.6001 13.7001 24.6001ZM13.7001 26.7001H6.20013C5.70013 26.7001 5.40015 26.3001 5.40015 25.9001C5.40015 25.4001 5.80013 25.1001 6.20013 25.1001H13.7001C14.2001 25.1001 14.5001 25.5001 14.5001 25.9001C14.5001 26.4001 14.1001 26.7001 13.7001 26.7001Z" fill="#FFFF99"/>
                            <path d="M19.3 22.2001C19.2 22.1001 17.8 20.7001 17.8 16.8001C17.8 12.9001 18.4001 11.4001 18.4001 11.4001V11.3001V11.2001C18.4001 11.2001 18.1 8.4001 18.1 6.2001C18.1 4.7001 17.5001 3.80008 16.0001 3.30008V2.7001C16.0001 1.5001 15.0001 0.600098 13.9001 0.600098H13.0001C11.8001 0.600098 10.9001 1.6001 10.9001 2.7001V2.80008C10.6001 2.80008 10.3001 2.80008 10.0001 2.80008C9.80006 2.80008 9.60009 2.80008 9.40009 2.80008C9.40009 1.60008 8.40005 0.700104 7.30005 0.700104H6.50006C5.30006 0.700104 4.40009 1.70008 4.40009 2.80008V3.30008C2.70009 3.80008 2.00006 4.6001 2.00006 6.2001C2.00006 8.4001 1.70007 11.1001 1.70007 11.2001V11.3001V11.4001C1.70007 11.4001 2.30005 12.9001 2.30005 16.8001C2.30005 20.6001 0.900085 22.1001 0.900085 22.1001L0.800049 22.2001V27.4001V27.6001V29.9001C0.800049 30.7001 1.40007 31.3001 2.20007 31.3001H3.90009V45.4001L6.00006 47.2001V50.7001C6.00006 51.2001 6.40005 51.5001 6.80005 51.5001C7.30005 51.5001 7.60004 51.1001 7.60004 50.7001V47.2001L9.70007 45.4001V31.3001H10.7001V45.4001L12.8 47.2001V50.7001C12.8 51.2001 13.2 51.5001 13.6 51.5001C14.1 51.5001 14.4001 51.1001 14.4001 50.7001V47.2001L16.5001 45.4001V31.3001H18.2001C19.0001 31.3001 19.6 30.7001 19.6 29.9001V27.6001V27.4001V22.3001L19.3 22.2001ZM11.3 2.90009C11.3 2.00009 12.0001 1.30008 12.9001 1.30008H13.7001C14.6001 1.30008 15.3 2.00009 15.3 2.90009V3.30008C14.4 3.10008 13.1 3.00009 11.3 2.90009ZM15.2001 3.80008L15.7001 23.0001C15.4001 22.9001 15.1001 22.8001 14.7001 22.7001V9.40009L14.5001 9.30008C14.3001 9.20008 14.1001 9.2001 13.9001 9.1001C12.8001 8.8001 11.5 8.6001 10.1 8.6001C8.70004 8.6001 7.40005 8.8001 6.30005 9.1001C6.10005 9.2001 5.90007 9.20008 5.70007 9.30008L5.50006 9.40009V22.7001C5.10006 22.7001 4.80006 22.8001 4.50006 23.0001L5.00006 3.80008C6.00006 3.60008 7.40004 3.50009 9.10004 3.50009C9.40004 3.50009 9.60009 3.50009 9.90009 3.50009C12.4001 3.40009 14.0001 3.50008 15.2001 3.80008ZM16.2001 27.4001H14.7001V27.8001C14.7001 28.2001 14.3001 28.6001 13.9001 28.6001H5.90009C5.50009 28.6001 5.10004 28.2001 5.10004 27.8001V27.4001H3.90009V24.6001C3.90009 24.5001 4.00007 23.1001 5.70007 23.1001H14.4001C16.1001 23.1001 16.2001 24.5001 16.2001 24.5001V27.4001ZM6.00006 22.7001V9.7001C6.10006 9.7001 6.30009 9.6001 6.40009 9.6001C7.50009 9.3001 8.70004 9.1001 10.1 9.1001C11.4 9.1001 12.7 9.3001 13.8 9.6001C14 9.6001 14.1001 9.7001 14.2001 9.7001V22.7001H6.00006ZM4.70007 2.90009C4.70007 2.00009 5.40005 1.30008 6.30005 1.30008H7.10004C8.00004 1.30008 8.70007 2.00009 8.70007 2.90009V3.00009C8.60007 3.00009 8.50009 3.00009 8.40009 3.00009C8.30009 3.00009 8.20004 3.00009 8.10004 3.00009C7.90004 3.00009 7.80004 3.00009 7.60004 3.00009C7.50004 3.00009 7.50009 3.00009 7.40009 3.00009C7.20009 3.00009 7.00005 3.00009 6.80005 3.00009C6.70005 3.00009 6.70004 3.00009 6.60004 3.00009C6.50004 3.00009 6.30007 3.00009 6.20007 3.00009C6.10007 3.00009 6.10006 3.00009 6.00006 3.00009C5.90006 3.00009 5.80007 3.00009 5.70007 3.00009C5.60007 3.00009 5.60006 3.00009 5.50006 3.00009C5.40006 3.00009 5.30007 3.00009 5.20007 3.00009C5.10007 3.00009 5.10006 3.00009 5.00006 3.00009C4.90006 3.00009 4.80007 3.00009 4.70007 3.00009C4.60007 3.00009 4.60006 3.00009 4.50006 3.00009C4.50006 3.00009 4.50009 3.00009 4.40009 3.00009V2.90009H4.70007ZM1.10004 22.4001C1.40004 22.0001 2.60004 20.4001 2.60004 16.8001C2.60004 13.2001 2.10006 11.6001 2.00006 11.3001C2.00006 10.9001 2.30005 8.30008 2.30005 6.30008C2.30005 5.10008 2.70006 4.30008 4.50006 3.80008L4.00006 23.3001C3.50006 23.8001 3.40009 24.5001 3.40009 24.5001V27.3001H1.00006V22.4001H1.10004ZM9.00006 45.3001L6.90009 47.1001V50.8001C6.90009 51.0001 6.70004 51.1001 6.60004 51.1001C6.40004 51.1001 6.30005 50.9001 6.30005 50.8001V47.1001L4.20007 45.3001V31.4001H9.00006V45.3001ZM15.7001 45.3001L13.6 47.1001V50.8001C13.6 51.0001 13.4 51.1001 13.3 51.1001C13.1 51.1001 13.0001 50.9001 13.0001 50.8001V47.1001L10.9001 45.3001V31.4001H15.7001V45.3001ZM18.8 29.9001C18.8 30.4001 18.4001 30.8001 17.9001 30.8001H16.2001H10.4001H9.40009H3.60004H2.00006C1.50006 30.8001 1.10004 30.4001 1.10004 29.9001V27.8001H4.70007C4.70007 28.5001 5.30006 29.0001 6.00006 29.0001H14.0001C14.7001 29.0001 15.3 28.4001 15.3 27.8001H18.9001V29.9001H18.8ZM16.7001 27.4001V24.6001C16.7001 24.6001 16.6 23.9001 16.1 23.4001L15.6 4.00009C17.1 4.50009 17.5001 5.30009 17.5001 6.40009C17.5001 8.40009 17.8 10.9001 17.8 11.4001C17.7 11.7001 17.2001 13.3001 17.2001 16.9001C17.2001 20.5001 18.4001 22.1001 18.7001 22.5001V27.5001H16.7001V27.4001Z" fill="#36393B"/>
                        </svg>
                    </div>
                </div>
                <InjectionProcessEndedView
                        v-else-if="[injectionStatuses.ended, injectionStatuses.interrupted].includes(injectionStatus)"
                        :completed-protocols-list="completedProtocolsList"
                        :max-pressure="maxPressure"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {gsap} from 'gsap';
    import { ref, computed } from '@vue/composition-api'

    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { fas } from '@fortawesome/free-solid-svg-icons'
    library.add(fas);



    import FluidA from '@/components/FluidA'
    import FluidB from '@/components/FluidB'
    import DateTime from '@/components/DateTime'
    import InjectionProcessRunningView
        from '@/components/InjectionProcess/InjectionProcessRunning/InjectionProcessRunningView'
    import InjectionProcessEndedView
        from '@/components/InjectionProcess/InjectionProcessEnded/InjectionProcessEndedView'


    export default {
        name: "InjectionProcessView",
        components: {
            FluidA,
            FluidB,
            DateTime,

            InjectionProcessRunningView,
            InjectionProcessEndedView,
            FontAwesomeIcon,
        },
        data() {
            return {
                injector_animation: '',
                animation_created: false,
            }
        },
        computed: {
            ...mapGetters('injector', {
                injection_started: 'injection_started'
            }),
            ...mapGetters([
                'current_phase'
            ]),
        },
        watch: {
            current_phase() {
                if (!this.animation_created) {
                    this.animation_created = true;
                    this.injector_animation = gsap.timeline({yoyo: true, repeat: -1, paused: true}),
                    this.injector_animation.to('.injector-body', {
                        fill: '#B6D1E3',
                        duration: 1,
                    })
                }
                if (this.current_phase === 'PAUSE' || this.current_phase === 'AWAITING') {
                    this.injector_animation.play();
                } else {
                    this.injector_animation.pause();
                    gsap.to('.injector-body', {
                        fill: '#FFFF99',
                    })
                }
            },
        },
        setup(props, { root }) {
            /** INJECTION STATUS HANDLE **/
            const injectionStatus = ref(undefined)
            const injectionStatuses = {
                running: 'running',
                ended: 'ended',
                interrupted: 'interrupted'
            }
            const _setInjectionStatusRunning = () => injectionStatus.value = injectionStatuses.running
            const _setInjectionStatusEnded = () => injectionStatus.value = injectionStatuses.ended
            const _setInjectionStatusInterrupted = () => injectionStatus.value = injectionStatuses.interrupted
            const injectionStatusHandleModule = {injectionStatus, injectionStatuses}


            /** TIME EXPIRATION **/
            const expiredTime = ref(0)
            const isTimeExpiring = ref(false)
            const recurseTimeExpiration = () => {
                expiredTime.value += 1
                setTimeout(recurseTimeExpiration, 1000)
            }
            const startTimeExpiration = () => {
                isTimeExpiring.value = true
                recurseTimeExpiration()
            }
            // should be defined as util function
            const formattedTime = computed(() => {
                const addZeroIfNeed = num => num < 10 ? ('0' + num) : num

                const hours = addZeroIfNeed(Math.floor(expiredTime.value / 3600))
                const minutes = addZeroIfNeed(Math.floor((expiredTime.value % 3600) / 60))
                const seconds = addZeroIfNeed(expiredTime.value % 60)

                return `${hours}:${minutes}:${seconds}`
            })
            const timeExpirationModule = {formattedTime, isTimeExpiring}


            /** WORKFLOW HANDLE **/
            _setInjectionStatusRunning() // running view by default
            const completedProtocolsList = ref([{"duration":5,"type":"B","random":0.9802714494042499,"initialData":{"flowRate":"4,0","volume":20,"type":"B","duration":"00:05"}},{"duration":5,"type":"TEST","random":0.7108025632900713,"initialData":{"type":"Test"},"continued":true},{"duration":1,"type":"DUAL_FLOW","random":0.7216408810225701,"initialData":{"flowRate":"1,0","volume":"1","contrast":"50","saline":50,"type":"dualFlow","duration":"00:01"}},{"duration":3,"type":"B","random":0.5618792784462725,"initialData":{"flowRate":"2,0","volume":"5","type":"B","duration":"00:03"}},{"duration":3,"type":"B","random":0.8184892418262248,"initialData":{"flowRate":"4,0","volume":"12","type":"B","duration":"00:03"}},{"duration":2,"type":"B","random":0.6208060089026861,"initialData":{"flowRate":"4,0","volume":"8","type":"B","duration":"00:02"}}])
            const injectionStarted = () => startTimeExpiration()
            const injectionEnded = protocolsList => {
                completedProtocolsList.value = protocolsList
                _setInjectionStatusEnded()
            }
            const injectionInterrupted = protocolsList => {
                completedProtocolsList.value = protocolsList
                _setInjectionStatusInterrupted()
            }

            const workflowHandleModule = {
                completedProtocolsList, injectionEnded, injectionInterrupted, injectionStarted
            }

            const maxPressure = computed(() => parseInt(root.$store.getters.getPressureLimit.match(/\d+/)[0]))



            return {
                ...injectionStatusHandleModule,
                ...timeExpirationModule,
                ...workflowHandleModule,
                maxPressure
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "../../scss/mixin";
    @import "../../scss/variable";

    .interrupted {

        background: $yellow !important;

        h2 {
            color: red !important;
        }

    }

    .time {
        font-weight: 700;
        margin-right: 15px;
        font-size: 16px;
        position: relative;

        &:before {
            content: '';
            width: 20px;
            height: 20px;
            background: url('../../img/remind.svg') no-repeat;
            position: absolute;
            top: 0;
            left: -25px;
        }
    }

    .system-injection {
        position: absolute;
        bottom: 60px;
        right: 70px;
        width: 181px;
        @include border;

          .system-header {
            border-bottom: 1px solid $secondary-text-color;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-left: 10px;
            padding-right: 5px;
            height: 30px;

            background: rgba(255, 255, 255, 0.1);

            h2 {
              color: #fff;
              font-weight: 700;
            }

            svg {
              vertical-align: top;
            }
          }

          .system-window {
            height: 55px;
            display: flex;
            justify-content: flex-start;
            padding-top: 5px;
            padding-bottom: 5px;
            position: relative;
            padding-left: 15px;

            svg {
              height: 50px;
            }
          }

          .system-btn {
            background: none;
          }
      }
</style>